export default __webpack_public_path__ + "logo07c99fb7.png";